export const categoryOptions = ['shirts', 'polos', 'sweatpants', 'yetiflask'];
